export default __webpack_public_path__ + "static/media/tete81.4c3f0d1b.png";